import React from 'react';
import { withResolver } from 'components/common';
import { FormGroup } from 'components/common/Forms';
import { compose, withState } from 'recompose';
import { Control, track, actions } from 'react-redux-form';
import { Card, CardBody, Button, Row, Col } from 'reactstrap';
import { concat } from 'lodash';
import { Select, Creatable } from 'react-select';

export const InstallerDevices = ({ devices, item, readOnly}) => (
  <FormGroup>
    <Card>
      <CardBody>
        <FormGroup label="Devices"  >
          <Control.select
            model=".devices"
            placeholder="None Set"
            component={Creatable}
            options={devices}
            multi
            labelKey="device_name"
            valueKey="id"
            disabled={readOnly || item.is_all_devices}
          />
        </FormGroup>
        <FormGroup label="All Devices" check disabled={readOnly}>
          <Control.checkbox 
            model=".is_all_devices"
          />
        </FormGroup>
      </CardBody>
    </Card>
  </FormGroup>
);

const enhance = compose(
  withState('devices', 'setDevices', null),
  withResolver(	
    {	
      devices: () => client => client.get('devices'),	
    },	
    {	
      onResolved: ({ setDevices }) => ({ devices }) => {	
        setDevices(devices);	
      },	
    }	
  )
);

export default enhance(InstallerDevices);



// WEBPACK FOOTER //
// ./src/pages/Installers/InstallerDevices.jsx